import defineElement from "../helpers/defineElement.js";

/**
 * Element to provide a theme to its children elements, and down the tree.
 *
 * @param {object} [options]
 * @param {"default"|"dark-card"|"light-card"} [options.name] - Name of the theme to apply
 */
export default defineElement("theme", ({ name = "default" }, children) => {
	if (children.length > 1) {
		throw new Error("`theme` should only have one child");
	}

	if (children.length === 0) {
		throw new Error("`theme` should have one child");
	}

	return {
		options: { class: name },
		children: children[0],
	};
});
